module.exports = __webpack_public_path__ + "static/media/Reward_Center_Onboarding_Popup@3x.8cd8aa64.png";